import React from 'react';
import { Navigate } from 'react-router-dom';

const AdminProtectedRoute = ({ children }) => {
  const adminToken = localStorage.getItem('adminToken');
  const adminUser = localStorage.getItem('adminUser');

  if (!adminToken || !adminUser) {
    console.log('❌ No admin token or user found, redirecting to login');
    return <Navigate to="/admin/login" replace />;
  }

  try {
    const user = JSON.parse(adminUser);
    console.log('👤 Admin user:', user);

    const roleObj = user?.role;
    const roleName = (roleObj?.name || roleObj?.type || roleObj || '')
      .toString()
      .toLowerCase();

    console.log('🔐 Role object:', roleObj);
    console.log('📋 Role name:', roleName);

    // Check if user has admin or super admin role
    const isAdmin =
      roleName.includes('admin') ||
      roleName.includes('super') ||
      roleObj?.name?.toLowerCase().includes('admin') ||
      roleObj?.type?.toLowerCase().includes('admin');

    console.log('✅ Is Admin?', isAdmin);

    if (!isAdmin) {
      console.log('❌ User does not have admin role, redirecting to login');
      return <Navigate to="/admin/login" replace />;
    }
  } catch (error) {
    console.error('❌ Error parsing admin user:', error);
    return <Navigate to="/admin/login" replace />;
  }

  return children;
};

export default AdminProtectedRoute;
